import { useEffect, useState } from 'react';

/**
 * Return scroll direction for passed ref
 * @param [initialDirection]
 * @param [threshold]
 * @param [off]
 * @param [ref] - React Ref (if no ref specified, window will be used)
 * @param [useWindow]
 * @returns {string}
 */
export default ({ initialDirection = null, threshold = 64, off, ref, useWindow } = {}) => {
  const [direction, setDirection] = useState(initialDirection);

  useEffect(() => {
    if (ref && !ref.current) {
      return direction;
    }

    const element = useWindow ? window : ref.current;
    let lastScrollY = element[useWindow ? 'pageYOffset' : 'scrollTop'];
    let ticking = false;

    const updateDirection = () => {
      const scrollY = element[useWindow ? 'pageYOffset' : 'scrollTop'];
      if (Math.abs(scrollY - lastScrollY) < threshold) {
        ticking = false;
        return;
      }

      setDirection(scrollY > lastScrollY ? 'DOWN' : 'UP');
      lastScrollY = scrollY > 0 ? scrollY : 0;
      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateDirection);
        ticking = true;
      }
    };

    if (!off) {
      element.addEventListener('scroll', onScroll);
    } else {
      setDirection(initialDirection);
    }

    return () => element.removeEventListener('scroll', onScroll);
  }, [initialDirection, threshold, off]);

  return direction;
};
